export default __webpack_public_path__ + "static/jyby-2d746199103853a4edb967a6f9dd8660.jpeg";